const abbreviations = [
    {
        regex: /(\b)(AFAIK)(\b)/i,
        title: "As Far As I Know"
    }, {
        regex: /(\b)(AMA)(\b)/i,
        title: "Ask Me Anything"
    }, {
        regex: /(\b)(CCW)(\b)/i,
        title: "Comments and Criticism Welcome"
    }, {
        regex: /(\b)(CMV)(\b)/i,
        title: "Change My View"
    }, {
        regex: /(\b)(DAE)(\b)/i,
        title: "Does Anyone Else"
    }, {
        regex: /(\b)(DM;HS)(\b)/i,
        title: "Doesn’t Matter; Had Sex"
    }, {
        regex: /(\b)(ELI5)(\b)/i,
        title: "Explain Like I'm five"
    }, {
        regex: /(\b)(FIFY)(\b)/i,
        title: "Fixed It For You"
    }, {
        regex: /(\b)(FTFY)(\b)/i,
        title: "Fixed That For You"
    }, {
        regex: /(\b)(FWP)(\b)/i,
        title: "First World Problems"
    }, {
        regex: /(\b)(GGG)(\b)/i,
        title: "Good Guy Greg"
    }, {
        regex: /(\b)(GTFO)(\b)/i,
        title: "Get The F**k Out"
    }, {
        regex: /(\b)(HIFW)(\b)/i,
        title: "How I Feel When"
    }, {
        regex: /(\b)(HMB)(\b)/i,
        title: "Hold My Beer"
    }, {
        regex: /(\b)(IAmA)(\b)/i,
        title: "I Am A"
    }, {
        regex: /(\b)(IANAD)(\b)/i,
        title: "I Am Not A Doctor"
    }, {
        regex: /(\b)(IANAL)(\b)/i,
        title: "I Am Not A Lawyer"
    }, {
        regex: /(\b)(IIRC)(\b)/i,
        title: "If I Recall Correctly"
    }, {
        regex: /(\b)(IMO)(\b)/i,
        title: "In My Opinion"
    }, {
        regex: /(\b)(IMHO)(\b)/i,
        title: "In My Humble Opinion"
    }, {
        regex: /(\b)(IRL)(\b)/i,
        title: "In Real Life"
    }, {
        regex: /(\b)(ITAP)(\b)/i,
        title: "I Took A Picture"
    }, {
        regex: /(\b)(ITT)(\b)/i,
        title: "In This Thread"
    }, {
        regex: /(\b)(LOL)(\b)/,
        title: "Laugh Out Loud"
    }, {
        regex: /(\b)(LoL)(\b)/,
        title: "League of Legends"
    }, {
        regex: /(\b)(LPT)(\b)/i,
        title: "Life Pro Tip"
    }, {
        regex: /(\b)(MRW)(\b)/i,
        title: "My Reaction When"
    }, {
        regex: /(\b)(MFW)(\b)/i,
        title: "My Face When"
    }, {
        regex: /(\b)(NSFL)(\b)/i,
        title: "Not Safe For Life"
    }, {
        regex: /(\b)(NSFW)(\b)/i,
        title: "Not Safe For Work"
    }, {
        regex: /(\b)(OAG)(\b)/i,
        title: "Overly Attached Girlfriend"
    }, {
        regex: /(\b)(OC)(\b)/i,
        title: "Original Content"
    }, {
        regex: /(\b)(OP)(\b)/i,
        title: "Original Poster"
    }, {
        regex: /(\b)(PSA)(\b)/i,
        title: "Public Service Announcement"
    }, {
        regex: /(\b)(SMH)(\b)/i,
        title: "Shake My Head"
    },
    // {regex: /(\b)(SO)(\b)/i, title: "Significant Other"},
    {
        regex: /(\b)(TIFU)(\b)/i,
        title: "Today I F**ked Up"
    }, {
        regex: /(\b)(TIL)(\b)/i,
        title: "Today I Learned"
    }, {
        regex: /(\b)(YIL)(\b)/i,
        title: "Yesterday I Learned"
    }, {
        regex: /(\b)(TL;DR)(\b)/i,
        title: "Too Long; Didn't Read."
    }, {
        regex: /(\b)(WCGW)(\b)/i,
        title: "What Could Go Wrong"
    }, {
        regex: /(\b)(WIP)(\b)/i,
        title: "Work In Progress"
    }, {
        regex: /(\b)(WP)(\b)/i,
        title: "Writing Prompt"
    }, {
        regex: /(\b)(YMMV)(\b)/i,
        title: "Your Mileage May Vary"
    }, {
        regex: /(\b)(YSK)(\b)/i,
        title: "You Should Know"
    }
];

export const parseAbbr = string => abbreviations.reduce(
    (s, {regex, title}) => s.replace(regex, `$1<abbr title="${title}">$2</abbr>$3`),
    string
);


// WEBPACK FOOTER //
// ./src/apps/client-reddit/utils.js